<template>
    <div style="padding: 16px !important;background: #F0F2F5 !important;">
        <el-container>
            <el-container style="border-left:1px solid #E7EAEC" :style="conheight">
                <!-- <h3 class="flow_table_title">我的常用联系人列表</h3> -->
                <collapse-search>
                    <el-row>
                        <el-col :span="6">
                            <el-button
                                    type="primary"
                                    size="small"
                                    @click="operating('0', 'add')"
                                    icon="el-icon-plus"
                                    style="margin-left:0"
                            >{{ $t("common.add") }}</el-button
                            >
                            <eip-popconfirm-button
                                    type="danger"
                                    title="确定删除吗？"
                                    icon="el-icon-delete"
                                    @onConfirm="remove"
                                    style="margin-left:3px;"
                            >{{ $t("common.delete") }}</eip-popconfirm-button
                            >
                        </el-col>
                        <el-col :span="18">
                            <el-input
                                    size="small"
                                    style="width:380px"
                                    clearable
                                    placeholder="群组名称"
                                    prefix-icon="el-icon-search"
                                    v-model="groupName"
                            ></el-input>
                            <el-button
                                    style="margin-left: 20px"
                                    size="small"
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="search(true)"
                            >{{ $t("common.search") }}</el-button
                            >
                            <el-button size="small" icon="el-icon-refresh" @click="reset">{{
                                $t("common.reset")
                                }}</el-button>
                        </el-col>
                    </el-row>
                </collapse-search>
                <el-main class="approval-item__content">
                    <el-table
                            :data="rows"
                            stripe
                            border
                            style="width: 100%;"
                            header-cell-class-name="todo-header-row"
                            row-class-name="todo-row"
                            size="medium"
                            height="100%"
                            v-loading.fullscreen.lock="fullscreenLoading"
                            @selection-change="handleChecked"
                    >
                        <el-table-column
                                type="selection"
                                sortable
                                width="40"
                        ></el-table-column>
                        <el-table-column
                                prop="groupName"
                                label="群组名称"
                                align="center"
                        >
                            <template v-slot="{row,column,$index}">
                                <el-link
                                        type="primary"
                                        @click="operating(row.id,'edit')"
                                        title="点击修改群组内容"
                                >{{row.groupName}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                width="code"
                                label="群组编码"
                                align="center"
                        ></el-table-column>
                        <el-table-column
                                prop=""
                                :label="$t('common.operation')"
                                align="center"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <el-button
                                        @click="operating(scope.row.id, 'assignUser')"
                                        size="small"
                                        icon="el-icon-edit"
                                        plain
                                >分配人员</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <el-footer>
                    <el-row type="flex" justify="end">
                        <el-pagination
                                class="pagination"
                                :disabled="fullscreenLoading"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pagination.page"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="pagination.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pagination.total"
                        >
                        </el-pagination>
                    </el-row>
                </el-footer>
            </el-container>
        </el-container>
        <!--群组添加和编辑弹框-->
        <ht-sidebar-dialog
                width="28%"
                :title="title"
                :visible="dialogVisible"
                :before-close="handleClose"
                append-to-body
        >
            <el-form v-model="group" data-vv-scope="editGroupForm">
                <ht-form-item label="群组名称" prop="groupName" label-width="100px">
                    <ht-input
                            v-model="group.groupName"
                            autocomplete="off"
                            :validate="{required:true,regex: {
                        exp: '^[\\s\\S]{2,30}$',
                        message: '内容超出输入限制'
                      }}"
                            placeholder="请输入名称"
                            @change="changeGroupName"
                    ></ht-input>
                </ht-form-item>
                <ht-form-item label="群组编码" prop="code" label-width="100px">
                    <ht-input
                            v-model="group.code"
                            autocomplete="off"
                            :validate="{required:true,alpha_num:true,regex: {
                        exp: '^[\\s\\S]{2,30}$',
                        message: '内容超出输入限制'
                      }}"
                            placeholder="请输入编码">

                    </ht-input>
                </ht-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <ht-submit-button
                        :url="saveRoleUrl"
                        :model="group"
                        :is-submit="isSubmit"
                        request-method="POST"
                        scope-name="editGroupForm"
                        @before-save-data="beforeSaveData"
                        @after-save-data="afterSaveData"
                >{{$t('eip.common.save')}}</ht-submit-button>
                <el-button @click="handleClose">{{$t('eip.common.cancel')}}</el-button>
            </div>
        </ht-sidebar-dialog>
        <UserGroupManager ref="userGroupManager"></UserGroupManager>
    </div>
</template>

<script>
    import EipPopconfirmButton from "@/components/eipControl/EipPopconfirmButton";
    import UserGroupManager from "@/components/uc/UserGroupManager.vue";
    import req from "@/request.js";
    export default {
        name: "groupManagerList",
        components: {EipPopconfirmButton,UserGroupManager },
        computed:{
            saveRoleUrl:function () {
               return window.context.uc + "/uc/ucGroup/v1/save";
            }
        },
        data() {
            return {
                groupName: "",
                title: "添加群组",
                fullscreenLoading: false,
                dialogVisible: false,
                isSubmit: false,
                checkBoxData: [],
                group: {groupName:'',code:'',id:''},
                rows: [],
                pagination: {
                    pageBean: {
                        page: 1,
                        pageSize: 10,
                        total: 0
                    }
                },
                conheight:{ height:window.innerHeight-65+'px'},
            };
        },
        mounted(){
            window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
            this.search();
        },
        methods:{
            operating(id, action) {
                this.title="添加群组";
                if (action=='add'){
                    Object.assign(this.$data.group, this.$options.data().group);
                    this.dialogVisible=true;
                }else if (action=='assignUser'){
                    this.$refs.userGroupManager.showDialog(id);
                }  else{
                    this.title="编辑群组";
                    req.get("${uc}/uc/ucGroup/v1/"+id).then(res=>{
                        this.group=res.data;
                        this.dialogVisible=true;
                    })
                }

            },
            remove(){
                var ids = [];
                if (this.checkBoxData && this.checkBoxData.length > 0) {
                    for (let index = 0; index < this.checkBoxData.length; index++) {
                        ids.push(this.checkBoxData[index].id);
                    }
                }
                if (ids.length > 0) {
                    req.remove("${uc}/uc/ucGroup/v1/remove?ids="+ids).then(res=>{
                        if (res.data.state){
                            this.$message({
                                message: "刪除群组成功",
                                type: "success",
                                showClose: true
                            });
                            this.search();
                        }
                    })
                }else{
                    this.$message({
                        message: "请选择要删除的数据",
                        type: "warning",
                    });
                }
            },
            search(resetPage){
                if (resetPage) {
                    this.pagination = { page: 1, pageSize: 20, total: 0 };
                }
                let pageBean = { pageBean: this.pagination };
                this.fullscreenLoading=true;
                let querys = [];
                if (this.groupName){
                    querys.push({
                        property: "GROUP_NAME",
                        value: this.groupName,
                        group: "main",
                        operation: "LIKE",
                        relation: "AND"
                    });
                }
                pageBean.querys = querys;
                req.post("${uc}/uc/ucGroup/v1/query",pageBean)
                    .then(response => {
                        this.rows = response.data.rows;
                        this.pagination = {
                            page: response.data.page,
                            pageSize: response.data.pageSize,
                            total: response.data.total
                        };
                    }).finally(() => (this.fullscreenLoading = false));

            },
            reset() {
                this.groupName = "";
                this.search("find");
            },
            handleChecked(value) {
                this.checkBoxData = value;
            },
            handleSizeChange: function(size) {
                //每页下拉显示数据
                this.pagination.pageSize = size;
                this.search();
            },
            handleCurrentChange: function(currentPage) {
                //点击第几页
                this.pagination.page = currentPage;
                this.search();
            },
            handleClose() {
                this.dialogVisible = false;
            },
            async beforeSaveData() {
                this.isSubmit = true;
            },
            afterSaveData() {
                this.dialogVisible = false;
                this.search();
            },
            changeGroupName(){
                let groupName = this.group.groupName;
                this.$http.get(`${window.context.uc}/base/tools/v1/getPinyin?chinese=${groupName}&type=0`).then(resp=>{
                    this.group.code = resp.data.value;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/css/element-variables.scss";

/deep/ .el-table::before{
  display: none;
}

.el-table--group::after, .el-table--border::after{
  display: none;
}

/deep/.el-table--border th{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}


/deep/ .el-table{
  border: 0px !important;
  tr{
    max-height: 48px !important;
    height: 48px !important;
    line-height: 48px !important;
    td{
      padding: 0px !important;
      border-top: 0px solid #F0F2F5 !important;
      border-bottom: 1px solid #F0F2F5 !important;
      border-left: 0px solid #F0F2F5 !important;
      border-right: 0px solid #F0F2F5 !important;
    }
  }
  th{
    border: 0px;
  }
}


/deep/.el-table--border tr:hover > td{
    background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    }
    // .taskName{
    //   color: #1890FF !important;
    // }
}

// /deep/.el-table--border tr {
//   border-top: 0px solid #F0F2F5;
//   border-bottom: 1px solid #F0F2F5;
//   border-left: 0px solid #F0F2F5;
//   border-right: 0px solid #F0F2F5;
// }



//x3样式 隔行变色
/*
/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}

/deep/.el-table--border tr:hover > td{
    background-color:#fdfdaf !important;
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 0px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

*/
.list_main_content {
  padding: 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/ .todo-subject-read,
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 14px !important;
}




/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 0px solid #ededed;
}

.expand-collapse__search{
    margin: 16px 8px 16px 24px;
}

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}
/deep/ .el-main{
  padding: 0 24px 0px 24px !important;
}

/deep/ .expand-collapse__search .el-collapse-item__header{
  padding-right: 24px;
}

/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 24px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    height: 32px !important;
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 
</style>
